<template>
  <div>
    <div v-if="this.loadpage == true" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <b-card v-if="this.loadpage == false">
      <b-row>
        <b-col cols="12" md="9">
          <b-form-group label="เลือกรายการ :" label-cols-md="4">
            <div class="d-flex align-items-center">
              <b-form-radio-group
                v-model="choosePayment"
                stacked
                @change="clearVal"
              >
                <div v-for="list in paymentList" :key="list.length" class="pb-1">
                  <b-form-radio :value="list.value">
                    {{list.text}}
                  </b-form-radio>
                </div>
              </b-form-radio-group>
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="10" lg="9">
          <b-form-group v-if="choosePayment == 1" label="ยอดที่ต้องการเติม :" label-cols-md="4">
            <div class="d-flex align-items-center">
              <cleave
                v-model="amountTranfers"
                :options="options.amount"
                class="form-control col-md-7 col-lg-5"
              />
              <div class="pl-1">บาท</div>
            </div>
          </b-form-group>
          <b-form-group v-if="choosePayment == 3" label="ยอดที่ต้องการแลก:" label-cols-md="4">
            <cleave
              v-model="exchangeYuan"
              :options="options.amount"
              class="form-control col-md-7 col-lg-5"
            />
          </b-form-group>
          <b-form-group v-if="choosePayment == 4" label="ยอดที่ต้องกาฝากจ่าย/โอน :" label-cols-md="4">
            <cleave
              v-model="depTranfers"
              :options="options.amount"
              class="form-control col-md-7 col-lg-5"
            />
          </b-form-group>
          <b-form-group v-if="this.valAmount == false" label-cols-md="4">
            <small style="color:red">กรุณาระบุจำนวนเงิน</small>
          </b-form-group>
          <b-form-group v-if="choosePayment == 2" label="บิลที่ต้องการชำระ :" label-cols-md="4">
            <b-form-select
              v-model="chooseBill"
              :options="this.billList"
              value-field="paymentID"
              text-field="description"
              class="form-control col-md-7"
              :class="this.valBill == false ? 'mb-1' : null"
            >
              <b-form-select-option :value="null">--กรุณาเลือกรายการ--</b-form-select-option>
            </b-form-select>
            <br>
            <small v-if="this.valBill == false" style="color:red">กรุณาเลือกบิลที่ต้องการชำระ</small>
          </b-form-group>
          <b-form-group label-cols-md="4">
            <b-button class="mt-md-1" variant="primary" @click="toPayment">ดำเนินการ</b-button>
          </b-form-group>
        </b-col>
      </b-row>
    </b-card>

    <!-- modal payment -->
    <b-modal
      ref="payment"
      header-class="py-0 px-0 modal-header"
      hide-footer
      no-close-on-backdrop
      size="sm"
    >
    <template v-slot:modal-header>
      <div>
        <b-button @click="closeModal(1)" variant="flat-light">
          <feather-icon
            icon="XIcon"
            size="20"
          />
        </b-button>
      </div>
    </template>
      <!-- <form-wizard
        ref="refFormWizard"
        color="#7367F0"
        :title="null"
        :subtitle="null"
        hide-buttons
        class="checkout-form-wizard steps-transparent"
      >
        <tab-content
          title="Select"
          icon="feather icon-list"
        >
          <b-form>
            <div>111</div>
            <b-button @click="formWizardNextStep">next</b-button>
          </b-form>
        </tab-content>
        <tab-content
          title="Payment"
          icon="feather icon-credit-card"
          @change="loadQrCode()"
        >
          <b-form >
            <div>222</div>
            <b-button @click="formWizardNextStep">next</b-button>
          </b-form>
        </tab-content>
        <tab-content
          title="Success"
          icon="feather icon-check-circle"
        >
          <b-form >
            <div>333</div>
          </b-form>
        </tab-content>
      </form-wizard> -->

      <!-- step -->
      <div class="d-flex align-items-center pb-2 mt-n2">
        <div class="text-center mt-2">
          <b-avatar class="d-flex" variant="light-success" size="lg" text="1"/>
          <small>ช่องทาง<br>ชำระเงิน</small>
        </div>
        <!-- <hr :style="stepPay >= 1 ? 'border-top: 1px green inset;' : 'border-top: 1px solid inset;'" style="border-top: 1px solid inset; flex-grow: 1;"> -->
        <hr style="border-top: 1px solid inset; flex-grow: 1;">
        <div class="text-center">
          <b-avatar class="d-flex" :variant="stepPay >= 1 ? 'light-success' : 'light-secondary'" size="lg" text="2"/>
            <small>ดำเนินการ</small>
        </div>
        <hr style="border-top: 1px solid inset; flex-grow: 1;">
        <div class="text-center">
          <b-avatar class="d-flex" :variant="stepPay == 2 ? 'light-success' : 'light-secondary'" size="lg" text="3"/>
          <small>สำเร็จ</small>
        </div>
      </div>

      <!-- body -->
      <div class="justify-content-md-center">
        <div v-if="stepPay == 0">
          <div>
            <h4 class="text-center">เลือกช่องทางการชำระเงิน</h4>
            <h5 class="text-center pb-1">ยอดชำระ {{format_price(this.amountReview)}} บาท</h5>
            <b-form-radio-group
              v-model="chooseMethod"
              stacked
              @change="clearVal"
            >
              <div v-for="list in paymentMethod" :key="list.length" class="pb-1 d-flex align-items-center">
                <b-form-radio :value="list.value" class="pr-1">
                  {{list.text}}
                </b-form-radio>
                <b-img
                  v-if="list.value == 1"
                  :src="require('@/assets/icon-for-payment/qr-icon.png')"
                  fluid
                  width="30px"
                  height="30px"
                />
                <b-img
                  v-if="list.value == 2"
                  :src="require('@/assets/icon-for-payment/visa-mastercard.png')"
                  width="70px"
                  height="70px"
                  fluid
                />
              </div>
            </b-form-radio-group>
          </div>
          <div class="text-right">
            <b-button variant="primary" @click="nextStep(1)">ถัดไป>></b-button>
          </div>
        </div>
        <div v-if="stepPay == 1">
          <!-- qr code -->
          <div v-if="this.chooseMethod == 1">
            <div v-if="this.qrCode == null" class="text-center">
              <b-spinner
                style="width: 5rem; height: 5rem;"
                variant="primary"
                label="Large Spinner"
              />
            </div>
            <div v-if="this.qrCode != null">
              <h5 class="text-center pb-1">ยอดชำระ {{format_price(this.amountReview)}} บาท</h5>
              <b-img
                :src="`data:image/png;base64,${this.qrCode}`"
                fluid
                center
                class="pb-1"
              />
              <h5 v-if="this.iterations != null" class="text-center text-danger">
                ชำระเงินภายใน {{this.iterations}} วินาที
              </h5>
              <h5 v-if="this.iterations == null" class="text-center text-danger" @click="qrcodeAgain">
                <b-link>
                  ขอ QRCode อีกครั้ง
                </b-link>
              </h5>
              <div class="pb-1">
                <h5>*เมื่อแสกนชำระเรียบร้อยระบบจะอัพเดทยอดให้อัตโนมัติ</h5>
                <h5>
                  *หากชำระเรียบร้อยแล้วระบบไม่อัพเดทสถานะให้กรุณากดที่นี่ >> 
                  <b-button @click="checkStatusPayment" variant="primary" size="sm">เช็คสถานะการชำระเงิน</b-button>
                </h5>
              </div>
              <b-button variant="outline-danger" @click="backStep(0)"><<กลับ</b-button>
            </div>
          </div>

          <!-- credit/debit -->
          <div v-if="this.chooseMethod == 2">
            <h4 class="text-center">สรุปยอดชำระ</h4>
            <b-row class="px-lg-2">
              <b-col class="pr-0">ยอดที่ต้องการชำระ</b-col>
              <b-col class="text-right">{{format_price(this.amountPay)}} บาท</b-col>
            </b-row>
            <b-row class="px-lg-2">
              <b-col class="pr-0">ค่าธรรมเนียม</b-col>
              <b-col class="text-right">{{format_price(this.fee)}} บาท</b-col>
            </b-row>
            <b-row class="px-lg-2">
              <b-col class="pr-0">ยอดที่ต้องชำระทั้งหมด</b-col>
              <b-col class="text-right">{{format_price(this.amountPay + this.fee)}} บาท</b-col>
            </b-row>
            <div v-if="this.urlFlashpay == true">
              <div class="text-center text-danger py-1">กรุณาทำรายการที่หน้า FlashPay</div>
              <div>
                <div>*เมื่อชำระเรียบร้อยระบบจะอัพเดทยอดให้อัตโนมัติ</div>
                <div>
                  *หากชำระเรียบร้อยแล้วระบบไม่อัพเดทสถานะให้กรุณากดที่นี่ >> 
                  <b-button @click="checkStatusPayment" variant="primary" size="sm">เช็คสถานะการชำระเงิน</b-button>
                </div>
              </div>
            </div>
            <div class="pt-2">
              <b-button
                v-if="this.urlFlashpay == false"
                @click="reqPaymentCard()"
                class="float-right"
                variant="primary"
                :disabled="this.loadBtnCard == false"
              >
                <b-spinner v-if="this.loadBtnCard == false" small />
                ชำระเงิน
              </b-button>
              <b-button variant="outline-danger" @click="backStep(0)"><<กลับ</b-button>
            </div>
          </div>

          <!-- bank tranfer -->
          <div v-if="this.chooseMethod == 3">
            โอนธนาคาร
            <b-button @click="chgStep(2)">ต่อไป</b-button>
          </div>

        </div>
        <div v-if="stepPay == 2">
          <div class="text-center pb-1">
            <b-avatar
              variant="light-success"
              size="100"
            >
              <feather-icon
                icon="CheckCircleIcon"
                size="70"
              />
            </b-avatar>
            <h1 class="pt-1">สำเร็จ</h1>
            <h3>ยอดชำระ {{this.chooseMethod == 2 ? format_price(this.amountPay + this.fee) : format_price(this.amountReview)}} บาท</h3>
          </div>
          <div class="text-right">
            <b-button @click="closeModal(2)" variant="primary">
              ปิดหน้าต่าง ({{this.cd}})
            </b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BCard, BCardBody, BFormSpinbutton, BSpinner, BImg,
  BFormRadioGroup, BFormRadio, BFormSelect, BFormSelectOption, BCardHeader, BModal, VBToggle, BAvatar,
  BContainer, BLink,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ref } from '@vue/composition-api'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { format_price } from '@/views/global_function.js'
import axios from "axios";
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
import { defineAbility } from '@casl/ability'
export default {
  name: 'Taobao2youFlashPayment',

  components: {
    BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BCard, BCardBody, BFormSpinbutton, BSpinner, BImg,
    BFormRadioGroup, BFormRadio, BFormSelect, BFormSelectOption, BCardHeader, BModal, VBToggle,BAvatar,
    BContainer, BLink,

    //input
    Cleave,

    //next step
    // 3rd Party
    FormWizard,
    TabContent,
  },

  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },

  data() {
    return {
      userData: JSON.parse(localStorage.getItem('userData')),
      // payment type
      choosePayment: 1,
      paymentList: [
        { text: 'เติมเงินเข้า Balance', value: 1 },
        { text: 'ชำระบิลต่างๆ', value: 2 },
        { text: 'แลกเงินไทย -> จีน', value: 3 },
        { text: 'ทำรายการฝากจ่าย/โอนเงินไปจีน', value: 4 },
      ],

      // amount payment
      amountTranfers: '',
      exchangeYuan: '',
      depTranfers: '',
      options: {
        amount: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralPositiveOnly: true,
        },
      },
      valAmount: true,

      // bill list
      chooseBill: null,
      billList: [],
      valBill: true,

      // step payment
      chooseMethod: 1,
      paymentMethod: [
        { text: 'QR PAYMENT', value: 1 },
        { text: 'Credit Card/Debit Card', value: 2 },
        { text: 'โอนผ่านธนาคาร', value: 3 },
      ],
      stepPay: 0,
      qrCode: null,
      paymentIdCallback: [],
      rateExchange: [],

      amountReview: null,
      amountPay: null,
      fee: null,

      //นับเวลา
      iterations: null,
      interval: null,

      //นับเวลาเสร็จสิ้น
      startCd: null,
      cd: null,

      //เช็ค callback
      countCallback: null,
      setCallback: null,

      urlFlashpay: false,

      loadBtnCard: true,
      loadpage: true,
    };
  },

  async created() {
    await this.toFlashPay()
    await this.getRate()
    this.listPayment()
  },

  // setup() {
  //   const refFormWizard = ref(null)
  //   const formWizardNextStep = () => {
  //     refFormWizard.value.nextTab()
  //   }

  //   return {
  //     refFormWizard,
  //     formWizardNextStep,
  //   }
  // },

  methods: {
    toFlashPay() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const urlFP = urlParams.get('urlFlahpay')
      if (urlFP) {
        window.location.replace(urlFP, "_self")
      }
    },
    format_price,
    chgStep(stp) {
      this.stepPay = stp
      this.startCooldown()
    },
    async getRate() {
      let response = await axios.post(
        taobaoService_dotnet + 'api/General/get-exchange-rate',
        { headers: header_token }
      );
      this.rateExchange = response.data
    },
    async listPayment() {
      this.loadpage = true
      this.billList = []
      let response = await axios.post(
        taobaoService_dotnet + 'app/Payment/load-payment-page',
        {
          "loginToken": this.userData.data.customerInfo.loginToken,
        },
        { headers: header_token }
      );
      await response.data.balanceDeducts.forEach((e) => {
        if (e.paymentID != 4) {
          this.billList.push(e)
        }
      })
      this.loadpage = false
    },
    async toPayment(){
      if ( this.choosePayment == 1 && (this.amountTranfers == '' || this.amountTranfers == '0') ) {
        this.valAmount = false
      } else if (this.choosePayment == 3 && (this.exchangeYuan == '' || this.exchangeYuan == '0')) {
        this.valAmount = false
      } else if (this.choosePayment == 4 && (this.depTranfers == '' || this.depTranfers == '0')) {
        this.valAmount = false
      } else if (this.choosePayment == 2 && this.chooseBill == null) {
        this.valBill = false
      } else {
        var amount = null
        if (this.choosePayment == 1) {
          amount = Number(this.amountTranfers.replace(/,/g, ""))
        } else if (this.choosePayment == 3) {
          amount = Number(this.exchangeYuan.replace(/,/g, ""))
        } else if (this.choosePayment == 4) {
          amount = Number(this.depTranfers.replace(/,/g, ""))
        } else if (this.choosePayment == 2) {
          var billInfo = (this.billList.filter( x => x.paymentID == this.chooseBill)[0].description).split(" ")
          var billAmount = Number(billInfo[3].replace(/,/g, ""))
        }
        this.amountReview = this.choosePayment == 2 ? billAmount : amount
        this.$refs['payment'].show()
        this.valAmount = true
        this.valBill = true
      }
    },
    async closeModal(id) {
      if (id == 1) {
        this.$swal({
          title: 'ปิดหน้าต่างชำระเงิน ?',
          text: "คุณแน่ใจหรือป่าวว่าต้องการปิดหน้าต่างชำระเงิน ?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then( async result => {
          if (result.value) {
            this.valAmount = true
            this.valBill = true
            this.stepPay = 0
            this.qrCode = null
            this.paymentIdCallback = []
            this.cd = null
            this.urlFlashpay = false
            clearInterval(this.setCallback);
            clearInterval(this.cooldown);
            this.$refs['payment'].hide()
          }
        })
      } else if (id == 2) {
        this.valAmount = true
        this.valBill = true
        this.stepPay = 0
        this.qrCode = null
        this.paymentIdCallback = []
        this.cd = null
        clearInterval(this.setCallback);
        clearInterval(this.cooldown);
        this.$refs['payment'].hide()
        await this.$router.push({path: '/'})
        this.$router.push({path: '/finance/flash-payment'})
      }
    },
    clearVal () {
      this.valAmount = true
      this.valBill = true
      this.stepPay = 0
      this.qrCode = null
      this.paymentIdCallback = []
      clearInterval(this.setCallback);
    },
    async nextStep(count) {
      this.stepPay = count
      this.reqPayment()
    },

    //แจ้งชำระเงิน
    async reqPayment() {
      var amount = null
      var des = ''
      var payId = null
      if (this.choosePayment == 1) {
        amount = Number(this.amountTranfers.replace(/,/g, ""))
        des = 'เติมเงินเข้า Balance'
      } else if (this.choosePayment == 3) {
        amount = Number(this.exchangeYuan.replace(/,/g, ""))
        des = 'แลกเงิยไทย->จีน ยอด ' + (amount / this.rateExchange.topUpRate).toFixed(2) + ' หยวน'
      } else if (this.choosePayment == 4) {
        amount = Number(this.depTranfers.replace(/,/g, ""))
        des = 'ทำรายการฝากจ่าย/โอนเงินไปจีน ยอด ' + (amount / this.rateExchange.topUpRate).toFixed(2) + ' หยวน'
      } else if (this.choosePayment == 2) {
        payId = this.chooseBill
      }

      //qr code
      if (this.chooseMethod == 1) {
        if (this.choosePayment == 2) {
          let response = await axios.post(
            taobaoService_dotnet + 'app/FlashPay/flashpay-create-order-pc?paymentOrderId=' + payId,
            // "https://localhost:5001/app/FlashPay/flashpay-create-order-pc?paymentOrderId=" + payId,
            { headers: header_token }
          );
          this.paymentIdCallback = response.data.outTradeNo.split("_")
          this.qrCode = response.data.qrImage;
          if (response.data.message == "Request Succeeded") {
            this.start()
            this.checkCallback(75)
          }
        } else {
          let responseReq = await axios.post(
            taobaoService_dotnet + 'app/FlashPay/flashpay-create-payment',
            // "https://localhost:5001/app/FlashPay/flashpay-create-payment",

            {
              "customerID": JSON.parse(localStorage.getItem('cusId')),
              "amount": amount,
              "description": des,
              "PaymentId": payId
            },
            { headers: header_token }
          );
          if (responseReq.data.message == 'success') {
            let response = await axios.post(
              taobaoService_dotnet + 'app/FlashPay/flashpay-create-order-pc?paymentOrderId=' + responseReq.data.paymentId,
              // "https://localhost:5001/app/FlashPay/flashpay-create-order-pc?paymentOrderId=" + responseReq.data.paymentId,
              { headers: header_token }
            );
            this.paymentIdCallback = await response.data.outTradeNo.split("_")
            this.qrCode = response.data.qrImage;
            if (response.data.message == "Request Succeeded") {
              this.start()
              this.checkCallback(75)
            }
          }
        }
      }
      // credit/debit
      else if (this.chooseMethod == 2) {
        if (this.choosePayment == 2) {
          var billInfo = (this.billList.filter( x => x.paymentID == this.chooseBill)[0].description).split(" ")
          var billAmount = Number(billInfo[3].replace(/,/g, ""))
          this.amountPay = billAmount
          this.fee = Number(billAmount * 0.028)
        } else {
          this.amountPay = amount
          this.fee = Number(amount * 0.028)
        }
      }
    },

    async reqPaymentCard() {
      this.loadBtnCard = false
      this.urlFlashpay = false
      var amount = null
      var des = ''
      var payId = null
      if (this.choosePayment == 1) {
        amount = Number(this.amountTranfers.replace(/,/g, ""))
        des = 'เติมเงินเข้า Balance'
      } else if (this.choosePayment == 3) {
        amount = Number(this.exchangeYuan.replace(/,/g, ""))
        des = 'แลกเงิยไทย->จีน ยอด ' + (amount / this.rateExchange.topUpRate).toFixed(2) + ' หยวน'
      } else if (this.choosePayment == 4) {
        amount = Number(this.depTranfers.replace(/,/g, ""))
        des = 'ทำรายการฝากจ่าย/โอนเงินไปจีน ยอด ' + (amount / this.rateExchange.topUpRate).toFixed(2) + ' หยวน'
      } else if (this.choosePayment == 2) {
        payId = this.chooseBill
      }
      if (this.choosePayment == 2) {
        var billInfo = (this.billList.filter( x => x.paymentID == this.chooseBill)[0].description).split(" ")
        var billAmount = Number(billInfo[3].replace(/,/g, ""))
      }
      let responseReq = await axios.post(
        taobaoService_dotnet + 'app/FlashPay/flashpay-create-payment',
        // "https://localhost:5001/app/FlashPay/flashpay-create-payment",

        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "amount": this.choosePayment == 2 ? billAmount : amount,
          "description": des,
          "PaymentId": payId
        },
        { headers: header_token }
      );
      if (responseReq.data.message == 'success') {
        let response = await axios.post(
          taobaoService_dotnet + 'app/FlashPay/flashpay-create-card?paymentOrderId=' + responseReq.data.paymentId,
          // "https://localhost:5001/app/FlashPay/flashpay-create-card?paymentOrderId=" + responseReq.data.paymentId,
          { headers: header_token }
        );
        this.paymentIdCallback = response.data.outTradeNo.split("_")
        if (response.data.message == "Request Succeeded") {
          var url = window.location.href
          this.urlFlashpay = true
          window.open(url+'?urlFlahpay='+response.data.redirectUrl)
          this.checkCallback(650)
        }
      }
      this.loadBtnCard = true
    },

    //ขอ qr code อีกครั้ง
    async qrcodeAgain() {
      let response = await axios.post(
        taobaoService_dotnet + 'app/FlashPay/flashpay-create-order-pc?paymentOrderId=' + parseInt(this.paymentIdCallback[0]),
        // "https://localhost:5001/app/FlashPay/flashpay-create-order-pc?paymentOrderId=" + parseInt(this.paymentIdCallback[0]),
        { headers: header_token }
      );
      this.paymentIdCallback = response.data.outTradeNo.split("_")
      this.qrCode = response.data.qrImage;
      if (response.data.message == "Request Succeeded") {
        this.start()
        this.checkCallback(75)
      }
    },

    //เช็ค callback จาก flashpay
    checkCallback(count) {
      this.countCallback = count;
      this.setCallback = setInterval(this.checkStatusCallback, 1000);
    },
    async checkStatusCallback() {
      this.countCallback--;
      let response = await axios.post(
        taobaoService_dotnet + 'app/FlashPay/callback-status?paymentId=' + parseInt(this.paymentIdCallback[0]),
        // "https://localhost:5001/app/FlashPay/callback-status?paymentId=" + parseInt(this.paymentIdCallback[0]),
        { headers: header_token }
      );
      if (this.countCallback == 0) {
        clearInterval(this.setCallback);
      } else if (response.data.message == "success"){
        clearInterval(this.setCallback);
        this.countCallback = null
        if (response.data.message == "success") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'แจ้งชำระเงินเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          // await this.$router.push({path: '/'})
          // this.$router.push({path: '/finance/flash-payment'})
          this.stepPay = 2
          this.startCooldown()
        }
      }
    },

    async checkStatusPayment() {
      var paymentId = this.paymentIdCallback[0] +'_' + this.paymentIdCallback[1]
      let response = await axios.post(
        taobaoService_dotnet + 'app/FlashPay/callback-status-flashpay?paymentOrderId=' + paymentId,
        // "https://localhost:5001/app/FlashPay/callback-status-flashpay?paymentOrderId=" + "929345_2022-08-24-14-03-34",
        { headers: header_token }
      );
      if (response.data.tradeStatus == 3) {
        clearInterval(this.setCallback);
        this.countCallback = null
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'แจ้งชำระเงินเรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.stepPay = 2
        this.startCooldown()
      }
    },

    //ตัวนับเวลารอจ่ายเงิน
    start() {
      this.iterations = 60;
      this.interval = setInterval(this.foo, 1000);
    },
    foo() {
      this.iterations--;
      if (this.iterations == 0){
        clearInterval(this.interval);
        this.iterations = null
      }
    },

    //ตัวนับเวลาเสร็จสิ้น
    startCooldown() {
      this.cd = 5;
      this.startCd = setInterval(this.cooldown, 1000);
    },
    async cooldown() {
      this.cd--;
      if (this.cd == 0){
        clearInterval(this.startCd);
        this.cd = null
        await this.$router.push({path: '/'})
        this.$router.push({path: '/finance/flash-payment'})
      }
    },

    backStep(count) {
      this.$swal({
        title: 'เลือกช่องทางชำระเงินใหม่ ?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการเลือกช่องทางชำระเงินใหม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          this.stepPay = count
          clearInterval(this.interval);
          clearInterval(this.startCd);
        }
      })
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '~@core/scss/base/pages/app-ecommerce.scss';
@import '~vue-form-wizard/dist/vue-form-wizard.min.css';
</style>

<style lang="scss" scoped>
.checkout-form-wizard ::v-deep {
  .wizard-tab-content {
    box-shadow: none !important;
    background: transparent !important;
    padding: 0;
  }
}
</style>
<style>
.modal-header {
  justify-content: right;
}
</style>
